import React from "react";
import { useTranslation } from "react-i18next";

import "./styles.scss";

export interface ICategoryChipsProps {
  categories: string[];
  max?: number;
}

export const CategoryChips: React.FunctionComponent<ICategoryChipsProps> = ({
  categories,
  max = 1,
}) => {
  const { t: _t } = useTranslation();

  const visible = categories.slice(0, max);
  const remaining = categories.length - visible.length;

  return (
    <div className="gbp-places-query-category-chips">
      {visible.map((category) => (
        <span
          className="gbp-places-query-category-chip"
          key={category}
          title={category}
        >
          {category}
        </span>
      ))}
      {remaining > 0 && (
        <span className="gbp-places-query-category-chip gbp-places-query-category-chip-more">
          {_t("internalToolsHomePage.gbp_places_query.list.table.category_more", {
            count: remaining,
          })}
        </span>
      )}
    </div>
  );
};

export default CategoryChips;
